import { render, staticRenderFns } from "./realTimeData.vue?vue&type=template&id=93a15aea&scoped=true&"
import script from "./realTimeData.vue?vue&type=script&lang=js&"
export * from "./realTimeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a15aea",
  null
  
)

export default component.exports